module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "col-lg-8 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "single-post"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "110px",
      "line-height": "60px",
      "border-bottom": "1px solid #cccccc"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.aboutinfo.title))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6 col-sm-6"
  }, [_c('ul', [_c('li', [_vm._v("• " + _vm._s(_vm.aboutinfo.date))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px !important",
      "position": "absolute",
      "right": "10%",
      "cursor": "pointer"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666666"
    }
  }, [_vm._v("浏览量：" + _vm._s(_vm.aboutinfo.visits))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap",
    staticStyle: {
      "margin-top": "50px",
      "line-height": "30px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutinfo.content)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 sidebar mt-5 mt-lg-0"
  }, [_c('div', {
    staticClass: "single-widget recent-posts-widget",
    staticStyle: {
      "border": "0px",
      "background": "#f7f8fc"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("拿度推荐")]), _vm._v(" "), _c('div', {
    staticClass: "blog-list"
  }, _vm._l((_vm.tuijianlist), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "width": "100%",
        "height": "250px",
        "border-bottom": "1px solid #cccccc",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.waiurl + '/jiejueinfo?id=' + item.contentid
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "150px"
      },
      attrs: {
        "src": _vm.newurl + item.ico
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "50px",
        "color": "black"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("• " + _vm._s(item.date))])])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding fangan_section1 section",
    staticStyle: {
      "height": "960px"
    }
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "color": "#e40230",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_vm._v("SOLUTION")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c25a8e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Jiejueinfo.vue
// module id = 101
// module chunks = 0